module.exports = __webpack_public_path__ + "img/pet_happy.40f04fd5.png";